import {
  SUBMIT_NAME,
  SUBMIT_NAME_FAILURE, SUBMIT_NAME_SUCCESS,
  SUBMIT_ZIP,
  SUBMIT_ZIP_FAILURE,
  SUBMIT_ZIP_SUCCESS,
  SUBMIT_PHONE,
  SUBMIT_PHONE_FAILURE,
  SUBMIT_PHONE_SUCCESS,
  CONFIRM_CODE,
  CONFIRM_CODE_FAILURE,
  CONFIRM_CODE_SUCCESS,
  UPDATE_STEP_FAILURE,
  UPDATE_STEP_SUCCESS,
} from '../actions/signupActions';

const signup = (state = [], action) => {
  switch (action.type) {
    case SUBMIT_NAME:
      return {
        ...state,
        loading: "", // fast check, no need for a loading screen here
        error: "",
      };

    case SUBMIT_NAME_FAILURE:
      return {
        ...state,
        loading: "",
        error: action.error,
      };

    case SUBMIT_NAME_SUCCESS:
      return {
        ...state,
        loading: "",
        step: "ENTER_ZIPCODE",
        firstname: action.data.firstname,
        lastname: action.data.lastname,
      };

    case SUBMIT_ZIP:
      return {
        ...state,
        loading: `you must really care about ${action.data.zipcode}`,
        error: "",
      };

    case SUBMIT_ZIP_FAILURE:
      return {
        ...state,
        loading: "",
        error: action.error,
      };

    case SUBMIT_ZIP_SUCCESS:
      return {
        ...state,
        loading: "",
        step: "ENTER_PHONE",
        zip: action.data.zipcode,
      };

    case SUBMIT_PHONE:
      return {
        ...state,
        loading: "sending confirmation code",
        error: "",
      };

    case SUBMIT_PHONE_FAILURE:
      return {
        ...state,
        loading: "",
        error: action.error,
      };

    case SUBMIT_PHONE_SUCCESS:
      return {
        ...state,
        loading: "",
        step: "CONFIRM_CODE",
        phone: action.data.phone,
      }

    case CONFIRM_CODE:
      return {
        ...state,
        loading: "confirming code",
        error: "",
      };

    case CONFIRM_CODE_FAILURE:
      return {
        ...state,
        loading: "",
        error: action.error,
      };

    case CONFIRM_CODE_SUCCESS:
      return {
        ...state,
        loading: "",
        step: "COMPLETE",
      };

    case UPDATE_STEP_SUCCESS:
      return {
        ...state,
        step: action.data.step,
      };

    case UPDATE_STEP_FAILURE:
      return {
        ...state,
        error: "Please complete the current step first.",
      };

    default:
      return state;
  }
};


export default signup;



// WEBPACK FOOTER //
// ./src/reducers/signup.js